exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flatpickr-confirm {\n\theight: 40px;\n\tmax-height: 0px;\n\tvisibility: hidden;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcursor: pointer;\n\tbackground: rgba(0,0,0,0.06)\n}\n\n.flatpickr-confirm svg path {\n\tfill: inherit;\n}\n\n.flatpickr-confirm.darkTheme {\n\tcolor: white;\n\tfill: white;\n}\n\n.flatpickr-confirm.visible {\n\tmax-height: 40px;\n\tvisibility: visible\n}\n", ""]);

// exports
